import React, { Component } from "react";
import "./Homepage.css";
import Cookie from 'js-cookie';
import {
  Empty, Button, Modal,
  Input, Radio, Form, message,
  Table, Divider, Icon, Select, Badge,
  Tag, Popconfirm, Spin, Tooltip,
  ConfigProvider, Upload
} from 'antd';
import Highlighter from 'react-highlight-words';
import { Link } from "react-router-dom";
import * as XLSX from "sheetjs-style";
import { saveAs } from 'file-saver';


//not usefull now
function handleChange(value) {
  // console.log(`selected ${value}`);
}

//create project modal
const CreateForm = Form.create({ name: 'form_in_modal' })(
  // eslint-disable-next-line
  class extends Component {
    render() {
      const Option = Select.Option;
      const { TextArea } = Input;

      const {
        visible, onCancel, onCreate, form, projectTags, licenseType
      } = this.props; //read all the property send from Homepage

      //print all the tags of this user
      const children = [];
      for (let i in projectTags) {
        children.push(<Option key={projectTags[i]}>{projectTags[i]}</Option>);
      }

      const { getFieldDecorator } = form; //can get the input value
      return (
        <Modal
          visible={visible} //control the showing of modal
          title="Create a new project"
          okText="Create"
          onCancel={onCancel}
          onOk={onCreate}
        >
          <Form layout="vertical">
            <Form.Item label="Project name">
              {getFieldDecorator('projectName', {
                rules: [{ required: true, message: 'Please input the title of project!' }], //set the rule
              })(
                <Input />
              )}
            </Form.Item>
            <Form.Item
              label="Project Tags"
            >
              {getFieldDecorator('projectTags', {
                rules: [
                  { required: true, message: 'Please choose at least one tag', type: 'array' }, //set the transfered data type
                ],
              })(
                //get all the tags
                <Select
                  mode="tags"
                  style={{ width: '100%' }}
                  onChange={handleChange}
                  placeholder="Please choose your project tags or create new tags">
                  {children}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="Project description">
              {getFieldDecorator('projectDescription')(
                <TextArea placeholder="Project description" autosize />
              )}
            </Form.Item>
            {/* <Form.Item label="Project type">
              {getFieldDecorator('projectType', {
                initialValue: 'MCA',
              })(
                <Radio.Group>
                  <Radio value="MCA">MCA</Radio>
                  {/* license function */}
            {/* {licenseType === "Free" ? <span><Radio disabled={true} value="MAMCA">MAMCA</Radio><Link to={`/licenseinfo`}><Tooltip title="Your MAMCA license has expired, click to check more info about license"><Icon type="question-circle" /></Tooltip></Link></span> : <Radio value="MAMCA">MAMCA</Radio>} */}
            {/* 
                </Radio.Group>
              )} */}
            {/* </Form.Item> */}
            <Form.Item label="Project evaluation type">
              {getFieldDecorator('projectEvaluationType', {
                initialValue: 'AHP',
              })(
                <Radio.Group>
                  <Radio value="AHP">AHP</Radio>
                  <Radio value="SMART">SMART</Radio>
                  <Radio value="Predefined">User Predefined</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </Form>
        </Modal>
      );
    }
  }
);

//edit project modal
let EditForm = Form.create({ name: 'edit_form_in_modal' })(
  // eslint-disable-next-line
  class extends Component {
    render() {
      const Option = Select.Option;

      const {
        visible, onCancel, onCreate, form, eproject, projectTags //get all the props from Homepage
      } = this.props;

      const children = []; //get all tags
      for (let i in projectTags) {
        children.push(<Option key={projectTags[i]}>{projectTags[i]}</Option>);
      }

      const { getFieldDecorator } = form;
      return (
        <Modal
          visible={visible}
          title={"Edit project " + eproject.projectName} //the name is different per modal
          okText="Edit"
          onCancel={onCancel}
          onOk={onCreate}
        >
          <Form layout="vertical">
            <Form.Item label="Project name">
              {getFieldDecorator('projectName', {
                rules: [{ required: true, message: 'Please input the title of project!' }],
                initialValue: eproject.projectName //get the oringinal project name
              })(
                <Input />
              )}
            </Form.Item>
            <Form.Item
              label="Project Tags"
            >
              {getFieldDecorator('projectTags', {
                rules: [
                  { required: true, message: 'Please choose at least one tag', type: 'array' },
                ],
                initialValue: eproject.projectTags //get the arrays of tags this project already has
              })(
                <Select
                  mode="tags"
                  style={{ width: '100%' }}
                  onChange={handleChange}
                  placeholder="Please choose your project tags or create new tags">
                  {children}
                </Select>
              )}
            </Form.Item>
            {/* <Form.Item label="Project type">
              {getFieldDecorator('projectType', {
                initialValue: eproject.projectType,
              })(
                <Radio.Group>
                  <Radio value="MCA">MCA</Radio>
                  <Radio value="MAMCA">MAMCA</Radio>
                </Radio.Group>
              )}
            </Form.Item> */}
            <Form.Item label="Project evaluation type">
              {getFieldDecorator('projectEvaluationType', {
                initialValue: eproject.projectEvaluationType,
              })(
                <Radio.Group>
                  <Radio value="AHP">AHP</Radio>
                  <Radio value="SMART">SMART</Radio>
                  <Radio value="Predefined">User Predefined</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </Form>
        </Modal>
      );
    }
  }
);

//Invite project modal
let InviteForm = Form.create({ name: 'invite_form_in_modal' })(
  // eslint-disable-next-line
  class extends Component {
    render() {
      const Option = Select.Option;

      const {
        visible, onCancel, onCreate, form, iproject //get all the props from Homepage
      } = this.props;

      const children = []; //get all tags
      if (iproject.projectActorGroup && iproject.projectActorGroup.length !== 0) {
        iproject.projectActorGroup.forEach(obj => {
          children.push(<Option key={obj.actorGroupName}>{obj.actorGroupName}</Option>)
        })
      }

      const { getFieldDecorator } = form;
      return (
        <Modal
          visible={visible}
          title={"Invite an evaluator in " + iproject.projectName} //the name is different per modal
          okText="Invite"
          onCancel={onCancel}
          onOk={onCreate}
        >
          <Form layout="vertical">
            <Form.Item label="Email">
              {getFieldDecorator('email', {
                rules: [{
                  type: 'email', message: 'The input is not valid E-mail!',
                }, {
                  required: true, message: 'Please input your E-mail!',
                }],
              })(
                <Input />
              )}
            </Form.Item>
            <Form.Item
              label='Actor Group'>
              {getFieldDecorator('actor', {
                rules: [{ required: true, message: 'Please input the actor!', whitespace: true }],
              })(
                <Select>
                  {children}
                </Select>
              )}
            </Form.Item>
            {/* <Form.Item label="Permisson">
              {getFieldDecorator('invitedPermission', {
                initialValue: ['Weight', 'Evaluation'],
              })(
                <Checkbox.Group style={{ width: '100%' }}>
                  <Row>
                    <Col span={8}>
                      <Checkbox value="Criteria">Criteria defining</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Weight">Weighting</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Evaluation">Evaluation</Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>,
              )}
            </Form.Item> */}
          </Form>
        </Modal>
      );
    }
  }
);

//Share project modal
let ShareForm = Form.create({ name: 'share_form_in_modal' })(
  // eslint-disable-next-line
  class extends Component {
    state = {
      users: this.props.userData[this.props.groupData[0]], //users in the group
      user: this.props.userData[this.props.groupData[0]][0], //first user
    };

    handleGroupChange = value => {
      this.setState({
        users: this.props.userData[value],
        user: this.props.userData[value][0],
      });
    };

    onUserChange = value => {
      this.setState({
        user: value,
      });
    };

    render() {

      const { users } = this.state;

      const Option = Select.Option;

      const {
        visible, onCancel, onCreate, form, sproject //get all the props from Homepage
      } = this.props;

      const { getFieldDecorator } = form;
      return (
        <Modal
          visible={visible}
          title={"Share project: " + sproject.projectName} //the name is different per modal
          okText="Share"
          onCancel={onCancel}
          onOk={onCreate}
        >
          <Form layout="vertical">
            <Form.Item label="Group">
              {getFieldDecorator('group', {
                rules: [
                  {
                    required: true, message: 'You must choose a group to continue!',
                  }],
              })(
                <Select
                  onChange={this.handleGroupChange}
                >
                  {this.props.groupData.map(group => (
                    <Option key={group}>{group}</Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="User to share">
              {getFieldDecorator('user', {
                rules: [
                  {
                    required: true, message: 'You must choose a user to continue!',
                  }],
              })(
                <Select
                  onChange={this.onUserChange}
                >
                  {users.map(u => (
                    <Option key={u}>{u}</Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Form>
        </Modal>
      );
    }
  }
);

export default class Homepage extends Component {
  constructor(props) {
    super(props);
    const groupData = ['fake'];
    const userData = {
      fake: ['fake'],
    };

    this.state = {
      email: Cookie.get("email"),
      searchText: '', //for the function of searching project name
      projectlist: [],
      projectNum: 0,
      createVisible: false, //for create modal
      editVisible: false, //for edit modal
      inviteVisible: false, //for invite modal
      shareVisible: false, //for share modal
      eproject: {}, //for project to edit
      iproject: {}, //for project to invite
      sproject: {}, //for project to share
      userGroups: [],
      groupData: groupData,
      userData: userData,
      params: {}, //for filter, save the params of changing
      projectTags: [],
      tagFilter: [], //for the tag to filter
      loading: true,
      soon: false,
    };
  }

  //function for searching, can be used on different column
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={`Search project name`} //${dataIndex}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ),
  })
  //for searching function
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }
  //for reseting the serach
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }
  //show or cancel create modal
  showCreateModal = () => {
    this.setState({ createVisible: true });
  }

  handleCreateCancel = () => {
    this.setState({ createVisible: false });
  }

  //show or cancel edit modal
  showEditModal = () => {
    this.setState({ editVisible: true });
  }

  handleEditCancel = () => {
    this.setState({ editVisible: false });
  }

  //show or cancel invite modal
  showInviteModal = () => {
    this.setState({ inviteVisible: true });
  }

  handleInviteCancel = () => {
    this.setState({ inviteVisible: false });
  }

  //show or cancel share modal
  showShareModal = () => {
    this.setState({ shareVisible: true });
  }

  handleShareCancel = () => {
    this.setState({ shareVisible: false });
  }
  //create project
  handleCreate = () => {
    const form = this.formRef.props.form; //get all the data from modal
    form.validateFields((err, values) => { //can get values based on name
      if (err || values.projectName.trim().length === 0) { //trim the project name to check the length
        return;
      }
      else {
        fetch('/project/createProject', { //REST create project
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: this.state.email,
            projectName: values.projectName.trim(), //trim the projectName, cannot have space
            projectTags: values.projectTags,
            projectDescription: values.projectDescription,
            projectType: "MAMCA",
            projectEvaluationType: values.projectEvaluationType,
          }),
        }).then(res => res.json())
          .then(json => {
            if (json.success) {
              this.getProjects(); //refresh project list
              this.getProjectTags() //refresh tag list
              this.getUserGroup() //refresh user group
              this.setState({ createVisible: false }); //make modal invisible
              message.success(json.message); //create successfully, show mesage
              form.resetFields(); //reset the form
            }
            else {
              message.error(json.message); //create unsuccessfully, show alert
            }
          });
      }
    });
  }

  //edit project
  handleEdit = () => {
    const form = this.EformRef.props.form; //get data from modal
    form.validateFields((err, values) => { //can get values based on name
      if (err || values.projectName.trim().length === 0) {
        return;
      }
      else {
        fetch('/project/editProject', { //REST edit project
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            uid: this.EformRef.props.eproject._id, //get the id of project
            email: this.state.email,
            projectName: values.projectName.trim(), //trim the projectName, cannot have space
            projectTags: values.projectTags,
            //  projectType: values.projectType,
            projectEvaluationType: values.projectEvaluationType,
          }),
        }).then(res => res.json())
          .then(json => {
            if (json.success) {
              this.getProjects(); //refresh project list
              this.getProjectTags(); //refresh tag list
              this.getUserGroup() //refresh user group
              this.handleEditCancel(); //make modal invisible
              message.success(json.message); //edit successful, show message
              form.resetFields();

            }
            else {
              message.error(json.message); //edit unsuccessful, show alert
            }
          });
        // console.log('Received values of form: ', values);
      }
    });
  }

  //invite project
  handleInvite = () => {
    const form = this.IformRef.props.form; //get data from modal
    form.validateFields((err, values) => { //can get values based on name
      if (err || values.email.trim().length === 0) {
        return;
      }
      else {
        fetch('/project/inviteProject', { //REST invite project
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            uid: this.IformRef.props.iproject._id, //get the id of project
            email: values.email,
            actor: values.actor,
            // invitedPermission: values.invitedPermission
          }),
        }).then(res => res.json())
          .then(json => {
            if (json.success) {
              this.getProjects(); //refresh project list
              this.getProjectTags(); //refresh tag list
              this.getUserGroup() //refresh user group
              this.handleInviteCancel(); //make modal invisible
              message.success(json.message); //invite successful, show message
              form.resetFields();

            }
            else {
              message.error(json.message); //invite unsuccessful, show alert
            }
          });
        // console.log('Received values of form: ', values);
      }
    });
  }

  //share project
  handleShare = () => {
    const form = this.SformRef.props.form; //get data from modal
    form.validateFields((err, values) => { //can get values based on name
      if (err || values.user.trim().length === 0) {
        return;
      }
      else {
        fetch('/project/shareProject', { //REST invite project
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            uid: this.SformRef.props.sproject._id, //get the id of project
            email: values.user,
          }),
        }).then(res => res.json())
          .then(json => {
            if (json.success) {
              this.getProjects(); //refresh project list
              this.getProjectTags(); //refresh tag list
              this.getUserGroup() //refresh user group
              this.handleShareCancel(); //make modal invisible
              message.success(json.message); //invite successful, show message
              form.resetFields();

            }
            else {
              message.error(json.message); //invite unsuccessful, show alert
            }
          });
      }
    });
  }
  //change function used for filter
  handleTableChange = (pagination, filters, sorter) => {
    // const pager = { ...this.state.pagination };
    // pager.current = pagination.current;
    // this.setState({
    //   pagination: pager,
    // });
    this.setState({ //save the params of changing, used for manually get projects
      params: {
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      }
    })
    this.getProjects({ //if something changed, get the project again
      // results: pagination.pageSize,
      // page: pagination.current,
      sortField: sorter.field,
      sortOrder: sorter.order,
      ...filters,
    });
  }

  //save all the form data of create
  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }
  //save all the form data of edit
  saveEFormRef = (formRef) => {
    this.EformRef = formRef;
  }

  //save all the form data of invite
  saveIFormRef = (formRef) => {
    this.IformRef = formRef;
  }

  //save all the form data of share
  saveSFormRef = (formRef) => {
    this.SformRef = formRef;
  }

  //get all the tags of this user
  getProjectTags = () => {
    fetch(`/project/getProjectTags/${Cookie.get("email")}/`, { //get method
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then(res => res.json())
      .then(json => {
        if (json.success) {
          this.setState({ //set state
            projectTags: json.taglist
          });
          const tagFilter = [];
          for (let i in json.taglist) { //save all the tags into json array
            tagFilter.push({
              text: json.taglist[i], //the key of text 
              value: json.taglist[i], //the key of value, which is needed in filter
            });
          }
          this.setState({
            tagFilter: tagFilter //save for the tage filter
          })
        }
      });
  }

  getUserInformation = () => {
    fetch(`/login/getUserInformation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: Cookie.get("email"),
      }),
    }).then(res => res.json())
      .then(json => {
        if (json.success) {
          this.setState({ //set state
            licenseType: json.user.licenseinfo.licenseType, //licensetype
            expire: json.expire,
            soon: json.soon
          });
        }
      });
  }

  getProjects = (params = {}) => { //get the project list
    let p = params
    //check if there is params saved
    if (Object.getOwnPropertyNames(params).length === 0) { //this situation happens when create new project and edit project, which can mannually check the change
      p = this.state.params //after creating or editing one project, component mounted but the filter data is cleared, so we read the params last time saved
    }
    fetch(`/project/getProjects`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: this.state.email,
        params: p //these params are used for filter function
      }),
    }).then(res => res.json())
      .then(json => {
        if (json.success) {
          this.setState({ //set state
            projectlist: json.projectlist.reverse(), //reverse the list to make it show in time order
            projectNum: json.projectlist.length, //save the length used for checking the status if there is any project created
            loading: false //to disable the loading status
          });
        }
      });
  }

  getUserGroup = () => {
    fetch(`/sharedProject/getUserGroups`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: this.state.email,
      }),
    }).then(res => res.json())
      .then(json => {
        if (json.success) {
          let groupData = []; //get all tags
          let userData = {}
          if (json.userGroups && json.userGroups.length !== 0) {
            json.userGroups.forEach(obj => {
              groupData.push(obj.GroupName)
              userData[obj.GroupName] = obj.GroupMember
            })
          }
          this.setState({ //set state
            userGroups: json.userGroups, //reverse the list to make it show in time order
            groupData: groupData,
            userData: userData,
          });
        }
      });
  }

  deleteProject(uid) { //delete project
    fetch('/project/deleteProject', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        uid: uid
      }),
    }).then(res => res.json())
      .then(json => {
        if (json.success) {
          this.getProjects(); //if success, refresh the project list
          this.getProjectTags(); //get the project tags
          message.success(json.message); //create successfully, show mesage
        }
        else {
          message.error(json.message); //create unsuccessful, show alert
        }
      });
  }

  resetProject(uid) { //delete project
    fetch('/project/resetProject', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        uid: uid
      }),
    }).then(res => res.json())
      .then(json => {
        if (json.success) {
          this.getProjects(); //if success, refresh the project list
          this.getProjectTags(); //get the project tags
          message.success(json.message); //create successfully, show mesage
        }
        else {
          message.error(json.message); //create unsuccessful, show alert
        }
      });
  }

  duplicateProject(uid) { //duplicate prject
    fetch('/project/duplicateProject', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        uid: uid,
      }),
    }).then(res => res.json())
      .then(json => {
        if (json.success) {
          this.getProjects(); //if success, refresh the project list
          message.success(json.message); //create successfully, show mesage
        }
        else {
          message.error(json.message); //create unsuccessful, show alert
        }
      });
  }

  downloadExcel = (uid) => {
    let project = {}
    fetch(`/project/getProject/${uid}/${Cookie.get("email")}/`, { //get the project id from link
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then(res => res.json())
      .then(json => {
        if (json.success) {
          project = json.project
          const { projectActorGroup, projectAlternatives, projectName, projectDescription, projectCreator, projectEvaluationType, projectTags } = project;

          // Prepare the workbook
          let wb = XLSX.utils.book_new();

          // Define styles
          const headerStyle = {
            font: { bold: true, color: { rgb: "FFFFFF" } },
            fill: { fgColor: { rgb: "4F81BD" } },
            alignment: { horizontal: "center", vertical: "center" },
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };

          const dataCellStyle = {
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
            alignment: { horizontal: "center", vertical: "center" },
          };

          const getValidSheetName = (name) => {
            return name.length > 31 ? name.slice(0, 28) + '...' : name;
          };
          // First tab: General project information
          let generalInfoData = [
            [{ v: 'Project Name:', s: headerStyle }, { v: projectName, s: dataCellStyle }],
            [{ v: 'Project Description:', s: headerStyle }, { v: projectDescription, s: dataCellStyle }],
            [{ v: 'Project Creator:', s: headerStyle }, { v: projectCreator, s: dataCellStyle }],
            [{ v: 'Project EvaluationType:', s: headerStyle }, { v: projectEvaluationType, s: dataCellStyle }],
            [{ v: 'Project Tags:', s: headerStyle }, { v: projectTags, s: dataCellStyle }],
            [],
            [{ v: 'Alternatives', s: headerStyle }, { v: 'Description', s: headerStyle }],
          ];

          projectAlternatives.forEach(alt => {
            generalInfoData.push([
              { v: alt.alternativeName, s: dataCellStyle },
              { v: alt.alternativeDescription || '', s: dataCellStyle },
            ]);
          });

          generalInfoData.push([]);

          projectActorGroup.forEach(actorGroup => {
            generalInfoData.push([{ v: `Actor Group: ${actorGroup.actorGroupName}`, s: headerStyle }]);
            generalInfoData.push([
              { v: 'Criteria/Subcriteria', s: headerStyle },
              { v: 'Main Criterion (if Sub)', s: headerStyle },
              { v: 'Description', s: headerStyle },
              { v: 'Indicator', s: headerStyle },
            ]);

            actorGroup.actorCriteria.forEach(criteria => {
              if (Array.isArray(criteria.subCriteria) && criteria.subCriteria.length > 0) {
                generalInfoData.push([
                  { v: criteria.criteriaName || '', s: dataCellStyle },
                  { v: '/', s: dataCellStyle },
                  { v: criteria.criteriaDescription || '', s: dataCellStyle },
                  { v: criteria.criteriaIndicator || '', s: dataCellStyle },
                ]);
                criteria.subCriteria.forEach(subCriteria => {
                  generalInfoData.push([
                    { v: subCriteria.subCriteriaName || '', s: dataCellStyle },
                    { v: criteria.criteriaName || '', s: dataCellStyle },
                    { v: subCriteria.subCriteriaDescription || '', s: dataCellStyle },
                    { v: subCriteria.subCriteriaIndicator || '', s: dataCellStyle },
                  ]);
                });
              } else {
                generalInfoData.push([
                  { v: criteria.criteriaName || '', s: dataCellStyle },
                  { v: '/', s: dataCellStyle },
                  { v: criteria.criteriaDescription || '', s: dataCellStyle },
                  { v: criteria.criteriaIndicator || '', s: dataCellStyle },
                ]);
              }
            });

            generalInfoData.push([]);
          });

          let generalInfoSheet = XLSX.utils.aoa_to_sheet(generalInfoData);
          XLSX.utils.book_append_sheet(wb, generalInfoSheet, 'Project Overview');

          // Actor Group Tabs
          projectActorGroup.forEach(actorGroup => {
            let data = [];

            // Headers with styles
            let headers = [{ v: 'Criteria/Subcriteria', s: headerStyle },
            ...projectAlternatives.map(a => ({ v: a.alternativeName, s: headerStyle })),
            { v: 'Weight value', s: headerStyle }];
            data.push(headers);

            // Loop over criteria and add data for each row
            actorGroup.actorCriteria.forEach(criteria => {
              if (Array.isArray(criteria.subCriteria) && criteria.subCriteria.length > 0) {
                // Loop through subcriteria
                criteria.subCriteria.forEach(subCriteria => {
                  // Calculate average weight for subcriteria
                  let totalWeight = 0;
                  let participantCount = subCriteria.actors.length;
                  subCriteria.actors.forEach(subActor => {
                    const mainActor = criteria.actors.find(a => a.actorEvaluator === subActor.actorEvaluator);
                    const mainCriteriaWeight = mainActor ? parseFloat(mainActor.actorCriteriaWeight) : 0;
                    const subCriteriaWeight = subActor ? parseFloat(subActor.actorSubCriteriaWeight) : 0;
                    const finalWeight = mainCriteriaWeight * subCriteriaWeight; // Weighted subcriteria
                    totalWeight += finalWeight;
                  });
                  const avgSubCriteriaWeight = participantCount > 0 ? (totalWeight / participantCount).toFixed(3) : 0;

                  // Calculate average scores for alternatives under subcriteria
                  let avgScores = projectAlternatives.map(alt => {
                    let totalScore = 0;
                    subCriteria.actors.forEach(subActor => {
                      const altResult = subActor.actorSubCriteriaResult.find(result => result.subCriteriaAlternativeName === alt.alternativeName);
                      totalScore += altResult ? altResult.subCriteriaAlternativeScore : 0;
                    });
                    return participantCount > 0 ? (totalScore / participantCount).toFixed(3) : ''; // Average score
                  });

                  // Create the row for subcriteria
                  let subRow = [
                    { v: subCriteria.subCriteriaName || '', s: dataCellStyle }, // Subcriteria name
                    ...avgScores.map(score => ({ v: score, s: dataCellStyle })),
                    { v: parseFloat(avgSubCriteriaWeight), s: dataCellStyle } // Weight
                  ];
                  data.push(subRow);
                });
              } else {
                // If no subcriteria, calculate average for main criteria
                let totalWeight = 0;
                let participantCount = criteria.actors.length;
                let avgScores = projectAlternatives.map(alt => {
                  let totalScore = 0;
                  criteria.actors.forEach(actor => {
                    const altResult = actor.actorCriteriaResult.find(result => result.criteriaAlternativeName === alt.alternativeName);
                    totalScore += altResult ? altResult.criteriaAlternativeScore : 0;
                  });
                  return participantCount > 0 ? (totalScore / participantCount).toFixed(3) : ''; // Average score
                });

                // Calculate the average weight
                criteria.actors.forEach(actor => {
                  totalWeight += parseFloat(actor.actorCriteriaWeight) || 0;
                });
                const avgCriteriaWeight = participantCount > 0 ? (totalWeight / participantCount).toFixed(3) : 0;

                // Create the row for the main criterion
                let row = [
                  { v: criteria.criteriaName || '', s: dataCellStyle }, // Criteria name
                  ...avgScores.map(score => ({ v: score, s: dataCellStyle })),
                  { v: parseFloat(avgCriteriaWeight), s: dataCellStyle } // Weight
                ];
                data.push(row);
              }
            });

            // Final Score Row
            let resultRow = [{ v: 'Final score', s: headerStyle }];
            projectAlternatives.forEach(alt => {
              let finalScore = 0;
              data.forEach(row => {
                const weight = parseFloat(row[row.length - 1].v); // Weight value is the last element in the row
                const altScore = parseFloat(row[headers.findIndex(h => h.v === alt.alternativeName)].v); // Alternative score
                if (!isNaN(weight) && !isNaN(altScore)) {
                  finalScore += altScore * weight;
                }
              });
              resultRow.push({ v: finalScore.toFixed(3), s: dataCellStyle });
            });
            resultRow.push({ v: '', s: dataCellStyle });
            data.push(resultRow);

            // Create the sheet for this actor group
            let ws = XLSX.utils.aoa_to_sheet(data);
            const validSheetName = getValidSheetName(actorGroup.actorGroupName);

            // Add the sheet to the workbook
            XLSX.utils.book_append_sheet(wb, ws, validSheetName);
          });

          const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
          const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
          saveAs(dataBlob, `${project.projectName}_${projectCreator}.xlsx`);
        }
        else {
          message.error(json.message)
        }
      });
    if (!project) return;
  };

  importExcel = async (file) => {
    try {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Get email from cookie
        const projectCreator = Cookie.get("email");

        // Define the getValidSheetName function
        const getValidSheetName = (name) => {
          return name.length > 31 ? name.slice(0, 28) + '...' : name;
        };

        // Initialize project data
        let projectData = {
          projectCreator,
          projectName: '',
          projectEvaluationType: '',
          projectTags: [],
          projectDescription: '',
          projectAlternatives: [],
          projectActorGroup: []
        };

        // Read the 'Project Overview' sheet
        const generalSheet = workbook.Sheets['Project Overview'];
        const generalData = XLSX.utils.sheet_to_json(generalSheet, { header: 1 });

        let i = 0;

        // Step 1: Extract project name and description
        for (; i < generalData.length; i++) {
          const row = generalData[i];
          if (row[0] === 'Project Name:') {
            projectData.projectName = row[1];
          } else if (row[0] === 'Project Description:') {
            projectData.projectDescription = row[1];
          } else if (row[0] === 'Project Creator:') {
            // Ignore, we get projectCreator from Cookie
          } else if (row[0] === 'Project EvaluationType:') {
            projectData.projectEvaluationType = row[1];
          } else if (row[0] === 'Project Tags:') {
            if (row[1]) {
              // If it's a comma-separated string, split it into an array
              projectData.projectTags = row[1].split(',').map(tag => tag.trim());
            } else {
              // If it's empty or undefined, set it to an empty array
              projectData.projectTags = [];
            } } 
            else if (row[0] === 'Alternatives') {
            i++;
            break; // Move to alternatives parsing
          }
        }

        // Step 2: Parse alternatives
        for (; i < generalData.length; i++) {
          const row = generalData[i];
          if (row.length === 0 || !row[0]) {
            i++; // Skip empty row
            break; // Alternatives parsing done
          }
          projectData.projectAlternatives.push({
            alternativeName: row[0],
            alternativeDescription: row[1] || '',
          });
        }

        // Step 3: Parse actor groups and their criteria
        while (i < generalData.length) {
          const row = generalData[i];
          if (row.length === 0 || !row[0]) {
            i++; // Skip empty row
            continue;
          }

          if (row[0].startsWith('Actor Group: ')) {
            // New actor group
            const actorGroupName = row[0].replace('Actor Group: ', '').trim();

            // Initialize actor group
            const currentActorGroup = {
              actorGroupName,
              actorCriteria: []
            };

            i++; // Move to criteria rows

            // Parse criteria and subcriteria for this actor group
            for (; i < generalData.length; i++) {
              const criteriaRow = generalData[i];
              if (criteriaRow.length === 0 || !criteriaRow[0]) {
                break; // End of criteria for this actor group
              }

              const isMainCriterion = criteriaRow[1] === '/';
              if (isMainCriterion) {
                // Main criterion
                const mainCriterion = {
                  criteriaName: criteriaRow[0],
                  criteriaDescription: criteriaRow[2] || '',
                  criteriaIndicator: criteriaRow[3] || '',
                  actors: [{
                    actorName: projectCreator,
                    actorEvaluator: projectCreator,
                    actorCriteriaWeight: 0,
                    actorCriteriaResult: []
                  }],
                  subCriteria: []
                };
                currentActorGroup.actorCriteria.push(mainCriterion);
              } else {
                // Subcriterion
                const subCriterionName = criteriaRow[0];
                const mainCriterionName = criteriaRow[1];
                const mainCriterion = currentActorGroup.actorCriteria.find(c => c.criteriaName === mainCriterionName);
                if (mainCriterion) {
                  const subCriterion = {
                    subCriteriaName: subCriterionName,
                    subCriteriaDescription: criteriaRow[2] || '',
                    subCriteriaIndicator: criteriaRow[3] || '',
                    actors: [{
                      actorName: projectCreator,
                      actorEvaluator: projectCreator,
                      actorSubCriteriaWeight: 0,
                      actorSubCriteriaResult: []
                    }]
                  };
                  mainCriterion.subCriteria.push(subCriterion);
                }
              }
            }

            // Use the truncated sheet name to find the sheet
            const sheetName = getValidSheetName(actorGroupName);
            const sheet = workbook.Sheets[sheetName];

            if (sheet) {
              const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
              const [headers, ...rows] = sheetData;

              // Map to store subcriteria weights per main criterion
              const mainCriteriaWeights = {};

              // Process rows to assign weights and scores
              rows.forEach(row => {
                const criterionName = row[0]; // Criterion or subcriterion name
                const weightValue = parseFloat(row[row.length - 1]) || 0; // Weight value
                const alternativeScores = row.slice(1, -1); // Scores for alternatives

                const mainCriterion = currentActorGroup.actorCriteria.find(c => c.criteriaName === criterionName);
                const subCriterion = currentActorGroup.actorCriteria
                  .flatMap(c => c.subCriteria)
                  .find(sc => sc.subCriteriaName === criterionName);

                if (subCriterion) {
                  // Subcriterion
                  const parentCriterion = currentActorGroup.actorCriteria.find(c => c.subCriteria.includes(subCriterion));
                  const parentName = parentCriterion.criteriaName;

                  // Accumulate subcriteria weights
                  if (!mainCriteriaWeights[parentName]) {
                    mainCriteriaWeights[parentName] = { sum: 0, subcriteria: [] };
                  }
                  mainCriteriaWeights[parentName].sum += weightValue;
                  mainCriteriaWeights[parentName].subcriteria.push({ subCriterion, weightValue });

                  // Assign the scores for the subcriterion
                  subCriterion.actors[0].actorSubCriteriaResult = alternativeScores.map((score, index) => ({
                    subCriteriaAlternativeName: headers[index + 1],
                    subCriteriaAlternativeScore: parseFloat(score) || 0
                  }));
                } else if (mainCriterion) {
                  // Main criterion
                  if (mainCriterion.subCriteria.length === 0) {
                    // No subcriteria, assign weight and scores directly
                    mainCriterion.actors[0].actorCriteriaWeight = weightValue;
                    mainCriterion.actors[0].actorCriteriaResult = alternativeScores.map((score, index) => ({
                      criteriaAlternativeName: headers[index + 1],
                      criteriaAlternativeScore: parseFloat(score) || 0
                    }));
                  } else {
                    // Has subcriteria, weight will be calculated later
                    // Optionally store the main criterion's scores if needed
                    // mainCriterion.mainAlternativeScores = alternativeScores; // Uncomment if needed
                  }
                }
              });

              // Now process main criteria with subcriteria to calculate weights
              Object.keys(mainCriteriaWeights).forEach(mainCriterionName => {
                const data = mainCriteriaWeights[mainCriterionName];
                const sumWeights = data.sum;
                const mainCriterion = currentActorGroup.actorCriteria.find(c => c.criteriaName === mainCriterionName);
                if (mainCriterion) {
                  // Assign the sum of subcriteria weights to the main criterion
                  mainCriterion.actors[0].actorCriteriaWeight = sumWeights;
                  // For each subcriterion, calculate partial weight and assign
                  data.subcriteria.forEach(item => {
                    const partialWeight = sumWeights > 0 ? item.weightValue / sumWeights : 0;
                    item.subCriterion.actors[0].actorSubCriteriaWeight = partialWeight;
                  });
                }
              });

            } else {
              // Default weights and scores to zero
              currentActorGroup.actorCriteria.forEach(criteria => {
                criteria.actors[0].actorCriteriaWeight = 0;
                criteria.actors[0].actorCriteriaResult = projectData.projectAlternatives.map(alt => ({
                  criteriaAlternativeName: alt.alternativeName,
                  criteriaAlternativeScore: 0
                }));
                criteria.subCriteria.forEach(sub => {
                  sub.actors[0].actorSubCriteriaWeight = 0;
                  sub.actors[0].actorSubCriteriaResult = projectData.projectAlternatives.map(alt => ({
                    subCriteriaAlternativeName: alt.alternativeName,
                    subCriteriaAlternativeScore: 0
                  }));
                });
              });
            }

            // Add the actor group to project data
            projectData.projectActorGroup.push(currentActorGroup);
          } else {
            i++; // Skip any rows that are not part of actor groups
          }
        }

        // Send the parsed project data to the server
        await fetch('/project/importExcelData', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ projectData })
        }).then(res => res.json())
          .then(response => {
            if (response.success) {
              message.success('Project imported successfully.');
            } else {
              message.error('Failed to import project.');
            }
          });
      };
      reader.readAsArrayBuffer(file);
      this.getProjects() //after render immediately get project list
      window.location.reload();

    } catch (error) {
      message.error('Error reading Excel file.');
    }
  };


  renderProjects() {
    const columns = [{ //the column title of the table
      title: 'Project Name', //the title of column
      dataIndex: 'projectName', //the data index can be used for searching, filtering
      key: 'projectName',
      ...this.getColumnSearchProps('projectName'), //make it can be search
      render: (text, record) => (<div>{this.state.licenseType === "Free" && record.projectType === "MAMCA" ? <span>{text}</span> : <Link to={`/alternative/${record._id}`}>{text}</Link>}</div>), //make it clickable to the project
      width: '20%',
    },
    // {
    //   title: 'Project Type',
    //   dataIndex: 'projectType',
    //   key: 'projectType',
    //   filters: [ //add the filter function
    //     { text: "MCA", value: "MCA" },
    //     { text: "MAMCA", value: "MAMCA" },
    //   ],
    //   width: '20%',
    // }, 
    {
      title: 'Project Evalution Type',
      dataIndex: 'projectEvaluationType',
      key: 'projectEvaluationType',
      filters: [ //add the filter function
        { text: "AHP", value: "AHP" },
        { text: "SMART", value: "SMART" },
        { text: "Predefined", value: "User Predefined" }
      ],
      width: '20%',
    }, {
      title: 'Tags',
      key: 'projectTags',
      dataIndex: 'projectTags',
      width: '20%',
      filters: this.state.tagFilter, //to show the list of tags of user can be filter
      render: tags => ( //print all the tag
        <span>
          {tags.map(tag => <Tag color="blue" key={tag}>{tag}</Tag>)}
        </span>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      width: '20%',
      render: (text, record) => (
        <span>
          {this.state.licenseType === "Free" && record.projectType === "MAMCA" ? <span><Link to={`/licenseinfo`} style={{ fontWeight: 'bold', color: 'red' }}>MAMCA license expired, check the license info!</Link></span> :
            <span>
              <Link to={`/alternative/${record._id}`}>Enter</Link>
              <Divider type="vertical" />
              {/* save the edited project data, which will be used later in edit modal, and then show the edit modal */}
              <Link to="#" onClick={() => { this.setState({ eproject: record }); this.showEditModal(); }}>Edit</Link>
              <Divider type="vertical" />
              {/* click to duplicate */}
              <Link to="#" onClick={() => { this.duplicateProject(record._id); }}>Duplicate</Link>
              <Divider type="vertical" />
              {/* after comfirmation we can delete the project */}
              <Popconfirm title="Are you sure you want to delete this project?" onConfirm={() => { this.deleteProject(record._id) }} okText="Yes" cancelText="No">
                <Link to="#">Delete</Link>
                <Divider type="vertical" />
              </Popconfirm>
              <Popconfirm title="Are you sure you want to reset this project?" onConfirm={() => { this.resetProject(record._id) }} okText="Yes" cancelText="No">
                <Link to="#">Reset</Link>
              </Popconfirm>
            </span>}
          {record.projectType === "MCA" ? <span></span> : this.state.licenseType === "Free" && record.projectType === "MAMCA" ? <span></span> : <Divider type="vertical" />}
          {record.projectType === "MCA" ? <span></span> : this.state.licenseType === "Free" && record.projectType === "MAMCA" ? <span></span> :
            <Link to="#" onClick={() => { this.setState({ iproject: record }); this.showInviteModal(); }}>Invite</Link>
          }
          <Divider type="vertical" />
          {/* {this.state.userGroups.length === 0 ? <span></span> : this.state.licenseType === "Free" && record.projectType === "MAMCA" ? <span></span> : <Link to="#" onClick={() => { this.setState({ sproject: record }); this.showShareModal(); }}>Share</Link>
          } */}
          <Link to="#" onClick={() => { this.downloadExcel(record._id); }}>Export</Link>

          {/* {record.projectType === "MCA" ? <span></span> : this.state.licenseType === "Free" && record.projectType === "MAMCA" ? <span></span> : <Divider type="vertical" />} */}
          {/* {record.projectType === "MCA" ? <span></span> : this.state.licenseType === "Free" && record.projectType === "MAMCA" ? <span></span> : <Link to={`/mamcasurveysetting/${record._id}`}>Survey</Link>
          } */}
        </span>
      ),
    }];

    return (
      <div>
        {this.state.expire ?
          <Button type="primary" size="large" disabled>License Expired</Button> :
          this.state.licenseType === "Student" && this.state.projectlist.length >= 1 ? <Button type="primary" size="large" disabled>Student license can only create one project</Button> :
          this.state.licenseType === "MAMCA" ? <Button type="primary" size="large" onClick={this.showCreateModal}><b>{"\uFF0B\n"}</b> Create a new project</Button>:<span></span>
        }
        {this.state.licenseType === "MAMCA" ?<Upload accept=".xlsx,.xls" customRequest={({ file }) => this.importExcel(file)}>
          <Button style={{ marginLeft: 10 }} size="large" type="primary" > Upload your project in Excel format</Button>
        </Upload>:<span></span>}
        {this.state.soon ?
          <span style={{ marginLeft: 10 }}>
            <Tooltip title="License will expire soon">
              <Badge dot>
                <Icon type="notification" />
              </Badge>
            </Tooltip>
          </span> : <span></span>}


        <div>&nbsp;</div>

        <Table columns={columns}
          rowKey={record => record._id} //unique key needed, so we use mongodb id
          dataSource={this.state.projectlist} //the data source is what we get after component mount
          onChange={this.handleTableChange} />
        <CreateForm
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.createVisible}
          onCancel={this.handleCreateCancel}
          onCreate={this.handleCreate}
          projectTags={this.state.projectTags} //send the tag list to the modal
          licenseType={this.state.licenseType}
        />
        <EditForm
          wrappedComponentRef={this.saveEFormRef}
          visible={this.state.editVisible}
          onCancel={this.handleEditCancel}
          onCreate={this.handleEdit}
          eproject={this.state.eproject} //send the edited project info to the modal
          projectTags={this.state.projectTags} //send the tag list to the modal
        />
        <InviteForm
          wrappedComponentRef={this.saveIFormRef}
          visible={this.state.inviteVisible}
          onCancel={this.handleInviteCancel}
          onCreate={this.handleInvite}
          iproject={this.state.iproject} //send the invited project info to the modal
        />
        <ShareForm
          wrappedComponentRef={this.saveSFormRef}
          visible={this.state.shareVisible}
          onCancel={this.handleShareCancel}
          onCreate={this.handleShare}
          sproject={this.state.sproject} //send the invited project info to the modal
          userGroup={this.state.userGroups} //send the user group can share
          groupData={this.state.groupData}
          userData={this.state.userData}
        />
      </div>
    );
  }

  componentDidMount() {
    try {
      this.getUserInformation() //for essential user information
      this.getProjects() //after render immediately get project list
      this.getProjectTags();
      this.getUserGroup();
    } catch (e) {
      alert(e);
    }
  }

  render() {
    return (
      <div className="Homepage" >
        {/* check if there is project */}
        <Spin size="large" tip="Loading..." spinning={this.state.loading}>
          <ConfigProvider renderEmpty={() => {
            return (<Empty />
            );
          }}>
            {this.renderProjects()}
          </ConfigProvider>
        </Spin>
      </div>
    );
  }
}